import React, {useMemo} from 'react';
import {
  HEADER_PLAN_LABELS,
  useBuilderPlanTypes,
  getMainPlanTypesFactory,
} from '../CreateBuilderHelpers';
import {builderFieldsType} from '../builderFields';
import AutoField from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import {useAccountContext} from '../../../../contexts/AccountContext';
import {useBuilderPlanOptionsField} from './useBuilderPlanOptionsField';

interface BuilderPlanOptionsProps {
  isSubmitting: boolean;
}

export function BuilderPlanOptions(props: BuilderPlanOptionsProps) {
  const {isSubmitting} = props;
  const {values} = useAutoForm<builderFieldsType>();
  const {account} = useAccountContext();

  const {mainPlanTypes} = useBuilderPlanTypes(values);
  const getMainPlanTypes = getMainPlanTypesFactory({
    values,
    mainPlanTypes,
  });
  const planTypes = getMainPlanTypes();

  // advicePlan is now computed via useBuilderAdvicePlan hook, not stored in state

  const selectedPlan = useMemo(() => {
    return planTypes.find((p) => p.value === values.mainPlanType);
  }, [planTypes, values.mainPlanType]);

  const selectedLabel = useMemo(() => {
    const label = values.planAction
      ? HEADER_PLAN_LABELS[values.planAction]?.first
      : 'Loading';
    // eslint-disable-next-line no-nested-ternary
    const planName = !selectedPlan
      ? undefined
      : selectedPlan.capitalise
      ? selectedPlan.label
      : selectedPlan.label.toLowerCase();
    const selectedLabelTemp = planName ? `${label} ${planName}` : `${label} plan`;
    return selectedLabelTemp;
  }, [selectedPlan, values.planAction]);

  const field = useBuilderPlanOptionsField({
    planTypes,
    selectedLabel,
    isSubmitting,
    values,
    account,
  });

  return <AutoField field={field} />;
}
